<form class="notd-noformat" novalidate #f="ngForm">
  <div class="input-wrapper">
    <input 
      type="text" 
      placeholder="{{placeholder}}" 
      class="form-control notd-team-price-editable text-right" 
      autocomplete="off"
      name="myPrice" 
      [attr.data-cy]="'price-team-input'"
      [disabled] = "disabled"

      pricevalidator 
      (validPrice) = "priceValid($event)"

      [decimals] = "decimals" 
      [max]="max" 
      [min]="min" 
      [allownull] ="allownull" 
      [hidden]="hidden" 
      [(ngModel)]="price" 
      >
    <div *ngIf="symbol" class="notd-stream-price-symbol">{{symbol}}</div>
  </div>

  <div class="error" *ngIf="f.controls.myPrice?.errors?.pricevalidator && f.controls.myPrice?.dirty">

      <div class="notd-input-error">
        <span *ngIf="f.controls.myPrice?.errors.pricevalidator.format">Wrong format, please type a number i.e: 12.01</span>
        <span *ngIf="f.controls.myPrice?.errors.pricevalidator.max">The number cannot be greater than {{f.controls.myPrice.errors.pricevalidator.maxvalue}}</span>
        <span *ngIf="f.controls.myPrice?.errors.pricevalidator.min">The number cannot be lower than {{f.controls.myPrice.errors.pricevalidator.minvalue}}</span>
        <span *ngIf="f.controls.myPrice?.errors.pricevalidator.decimals">The number cannot have more than {{f.controls.myPrice.errors.pricevalidator.decimalsvalue}} decimals</span>
        <span *ngIf="f.controls.myPrice?.errors.pricevalidator.decimalsformat">The number cannot be like 7. but 7.0</span>
        <span *ngIf="f.controls.myPrice?.errors.pricevalidator.integers">The number cannot be like .89 but 0.89</span>
    </div>

  </div>        
</form>
